import React from 'react'

class SC_GuildLine extends React.Component{
    render(){
        return(
            <div></div>
        )
    }
}
export default SC_GuildLine